import { render, staticRenderFns } from "./iconColor.vue?vue&type=template&id=d13272da&scoped=true&"
import script from "./iconColor.vue?vue&type=script&lang=js&"
export * from "./iconColor.vue?vue&type=script&lang=js&"
import style0 from "./iconColor.vue?vue&type=style&index=0&id=d13272da&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13272da",
  null
  
)

export default component.exports